import { Typography } from '@mui/material';
import { debounce } from '@vy/utils';
import React from 'react';
import { useFormContext } from 'react-hook-form';
import { VyDialog } from '../../../../components/new-design/feedback/VyDialog';
import { useUpdatePlan } from '../../../../hooks/requests/use-update-plan';
import type { useDialog } from '../../../../hooks/use-dialog';
import { useValidatedParams } from '../../../../hooks/use-validated-params';
import { useVyNavigate } from '../../../../hooks/use-vy-navigate';
import { parsePlanInput } from '../../../../utils/parse-plan-input';
import { runMutation } from '../../../../utils/vy-mutation';
import type { PlanInputForm } from '../../CreatePlanPage/create-plan-page-components/CreatePlanForm/create-plan-form-types/plan-input-form';

type UpdatePlanDialogProps = ReturnType<typeof useDialog>;

export const UpdatePlanDialog: React.FC<UpdatePlanDialogProps> = ({ isDialogOpen, handleClose }) => {
  const { planId } = useValidatedParams('planId');
  const navigate = useVyNavigate();

  const { getValues } = useFormContext<PlanInputForm>();

  const updatePlanMutation = useUpdatePlan();

  const handleFinalStep = async () => {
    const planInput = getValues();
    const parsedPlanResult = parsePlanInput(planInput, {
      errorContext: 'Update plan validation',
    });

    if (!parsedPlanResult.success) {
      return;
    }

    const parsedPlan = parsedPlanResult.data;

    await runMutation(
      updatePlanMutation,
      {
        planId,
        updatePlanRequest: parsedPlan,
      },
      {
        pending: 'Updating plan...',
        success: 'Plan updated successfully',
        error: 'Failed to update plan',
      },
    );

    navigate(`/plans/${planId}`);
  };

  return (
    <VyDialog
      label="Update Plan"
      ctaText="Update"
      cancelButtonText="Cancel"
      onSubmit={debounce(handleFinalStep)}
      open={isDialogOpen}
      onClose={handleClose}
    >
      <Typography>This action will update the plan.</Typography>
    </VyDialog>
  );
};
